import { render, staticRenderFns } from "./TransferSubDistrict.vue?vue&type=template&id=9a10b8d8"
import script from "./TransferSubDistrict.vue?vue&type=script&lang=js"
export * from "./TransferSubDistrict.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports